import * as React from "react";
import Select from "react-select";

var RegionSelector = function RegionSelector(props) {
  var _props$regions = props.regions,
      regions = _props$regions === void 0 ? [] : _props$regions,
      regionId = props.regionId,
      _onChange = props.onChange,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
  var regionsOptions = regions.map(function (region) {
    return {
      label: region.name,
      value: "".concat(region.id)
    };
  });
  var selectedRegion = regionId && regionsOptions.find(function (region) {
    return parseInt(region.value) === regionId;
  });
  return /*#__PURE__*/React.createElement(Select, {
    options: regionsOptions,
    value: selectedRegion,
    isSearchable: true,
    isDisabled: disabled,
    onChange: function onChange(item) {
      return _onChange && _onChange(parseInt(item.value));
    }
  });
};

export default RegionSelector;